<!-- ======= Header ======= -->
<material-navbar [transparent]="true" [container]="true" class="login-button-white"
  [menuPosition]="settings.get('vebto.navbar.defaultPosition')"></material-navbar>


<!-- ======= Hero Section ======= -->
<section id="hero" class="hero d-flex align-items-center">

  <div class="container">
    <div class="row">
      <div class="col-lg-6 d-flex flex-column justify-content-center">
        <h1 data-aos="fade-up">Start Selling Online</h1>
        <h2 data-aos="fade-up" data-aos-delay="400">boons is the easiest way to start, run and grow your online
          business.</h2>
        <div data-aos="fade-up" data-aos-delay="600">
          <div class="text-center text-lg-start">
            <a href="#" routerLink="/login"
              class="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center text-white" style="margin-top: 30px;">
              <span>Get Started</span>
              <i class="bi bi-arrow-right"></i>
            </a>
          </div>
          <div class="text-lg-start new">
            <h2>Also available on</h2>
            <div class="st-icon">
              <a href="javascript:void(0)" target="_blank">
                <img [src]="getTextureUrl('ios.svg')" alt="ios"></a>
              <a href="https://play.google.com/store/apps/details?id=com.boons.boons&hl=en_US&gl=US" class="ml-4" target="_blank">
                <img [src]="getTextureUrl('android.svg')" alt="android"></a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
        <img [src]="getTextureUrl('store-person-1.jpg')" class="img-fluid" alt="">
      </div>
    </div>
  </div>

</section><!-- End Hero -->

<main id="main">
  <!-- ======= About Section ======= -->
  <section id="about" class="about">

    <div class="container" data-aos="fade-up">
      <div class="row gx-0">

        <div class="col-lg-12 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay="200">
          <div class="content">
            <h2>Grocery Stores, Restaurants, Bakeries, Retail Shops or Food Trucks.. create online stores easily with
              boons. Start your dream business, today</h2>
          </div>
        </div>
      </div>
    </div>

  </section><!-- End About Section -->

  <!-- ======= Features Section ======= -->
  <section id="features" class="features">

    <div class="container" data-aos="fade-up">
      <header class="section-header">
        <h2>Features</h2>
        <p>Your dream business just three steps away!</p>
      </header>
      <div class="row new">
        <div class="col-lg-6">
          <img [src]="getTextureUrl('create-store.svg')" class="img-fluid" alt="">
        </div>
        <div class="col-lg-6 mt-5 mt-lg-0 d-flex">
          <div class="row align-self-center gy-4">
            <header class="section-header1">
              <h2 class="align-left">STEP ONE</h2>
            </header>
            <div>
              <h4 class="heading">Choose a Template</h4>
              <p class="text-desc">The nights you’ve lost, the fights you’ve fought... to find the perfect name.</p>
              <p class="text-desc">Name your store</p>
              <p class="text-desc">Modify Logo, Templates and Design as per need</p>
            </div>
          </div>
        </div>
      </div> <!-- / row -->
    </div>
    <!-- End Feature Tabs -->
    <div class="container" data-aos="fade-up">
      <div class="row new">
        <div class="col-lg-6 mt-5 mt-lg-0 d-flex">
          <div class="row align-self-center gy-4">
            <header class="section-header1">
              <h2 class="align-left">STEP TWO</h2>
            </header>
            <div>
              <h4 class="heading">Choose a Domain</h4>
              <p class="text-desc">The nights you’ve lost, the fights you’ve fought... to find the perfect name.</p>
              <p class="text-desc">Name your store</p>
              <p class="text-desc">Modify Logo, Templates and Design as per need</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <img [src]="getTextureUrl('product-listing.svg')" class="img-fluid" alt="">
        </div>
      </div> <!-- / row -->
    </div>
    <!-- End Feature Tabs -->
    <div class="container" data-aos="fade-up">
      <div class="row new">
        <div class="col-lg-6">
          <img [src]="getTextureUrl('start-selling.svg')" class="img-fluid" alt="">
        </div>
        <div class="col-lg-6 mt-5 mt-lg-0 d-flex">
          <div class="row align-self-center gy-4">
            <header class="section-header1">
              <h2 class="align-left">STEP THREE</h2>
            </header>
            <div>
              <h4 class="heading">Start Selling</h4>
              <p class="text-desc">The nights you’ve lost, the fights you’ve fought...</p>
              <p class="text-desc">This is where it all begins. Your store is ready for the world.</p>
              <p class="text-desc">Start sharing and taking orders</p>
            </div>
          </div>
        </div>
      </div> <!-- / row -->
    </div>
    <!-- End Feature Tabs -->

  </section><!-- End Features Section -->


  <!-- ======= Pricing Section ======= -->
  <section id="pricing" class="pricing">

    <div class="container" data-aos="fade-up">

      <header class="section-header">
        <h2>Start your brand new eCommerce store and impress your customers, with boons</h2>
        <p>The easiest way to sell anything online.</p>
      </header>

      <div class="row gy-4" data-aos="fade-left">

        <div class="col-lg-3 col-md-6" data-aos="zoom-in" data-aos-delay="100">
          <div class="box">
            <h3>Grocery Stores</h3>
            <img [src]="getTextureUrl('grocerystore.png')" class="img-fluid" alt="">
          </div>
        </div>

        <div class="col-lg-3 col-md-6" data-aos="zoom-in" data-aos-delay="200">
          <div class="box">
            <h3>Restaurants</h3>
            <img [src]="getTextureUrl('restaurants.png')" class="img-fluid" alt="">
          </div>
        </div>

        <div class="col-lg-3 col-md-6" data-aos="zoom-in" data-aos-delay="300">
          <div class="box">
            <h3>Bakeries</h3>
            <img [src]="getTextureUrl('bakeries.png')" class="img-fluid" alt="">
          </div>
        </div>

        <div class="col-lg-3 col-md-6" data-aos="zoom-in" data-aos-delay="400">
          <div class="box">
            <h3>Retail Shops</h3>
            <img [src]="getTextureUrl('retails.png')" class="img-fluid" alt="">
          </div>
        </div>

      </div>

    </div>

  </section><!-- End Pricing Section -->

  <!-- ======= Services Section ======= -->
  <section id="services" class="services">

    <div class="container" data-aos="fade-up">

      <header class="section-header">
        <h2>Services</h2>
        <p>E-commerce, made (incredibly) easy</p>
      </header>

      <div class="row gy-4">

        <div class="col-lg-4 p-5 col-md-6" data-aos="fade-up" data-aos-delay="200">
          <div class="service-box blue">
            <img [src]="getTextureUrl('icon/1.svg')" class="img-fluid" alt="">
            <h3>Design Tools</h3>
            <p class="servic">Make your store popular by designing amazing marketing materials from easy templates right within boons.
            </p>
          </div>
        </div>

        <div class="col-lg-4 p-5 col-md-6" data-aos="fade-up" data-aos-delay="300">
          <div class="service-box orange">
            <img [src]="getTextureUrl('icon/2.svg')" class="img-fluid" alt="">
            <h3>Restaurant Dining</h3>
            <p class="servic">Get more customers to your business, by running an easy to use table booking service, for your
              restaurant.</p>
          </div>
        </div>

        <div class="col-lg-4 p-5 col-md-6" data-aos="fade-up" data-aos-delay="400">
          <div class="service-box green">
            <img [src]="getTextureUrl('icon/3.svg')" class="img-fluid" alt="">
            <h3>Unique Themes</h3>
            <p class="servic">Make your store unique by choosing unique looks from a list of stunning themes and templates.</p>
          </div>
        </div>

        <div class="col-lg-4 p-5 col-md-6" data-aos="fade-up" data-aos-delay="500">
          <div class="service-box red">
            <img [src]="getTextureUrl('icon/4.svg')" class="img-fluid" alt="">
            <h3>Easy Pages</h3>
            <p class="servic">Grow your online store by publishing custom pages, using easy to use templates, readily available.</p>
          </div>
        </div>

        <div class="col-lg-4 p-5 col-md-6" data-aos="fade-up" data-aos-delay="600">
          <div class="service-box purple">
            <img [src]="getTextureUrl('icon/5.svg')" class="img-fluid" alt="">
            <h3>Custom Domain</h3>
            <p class="servic">Make your store unique by getting your own custom domain name that is easy to remember.</p>
          </div>
        </div>

        <div class="col-lg-4 p-5 col-md-6" data-aos="fade-up" data-aos-delay="700">
          <div class="service-box pink">
            <img [src]="getTextureUrl('icon/6.svg')" class="img-fluid" alt="">
            <h3>Online Payments</h3>
            <p class="servic">Get more sales, by offering seamless and easy payment options on your online store with boons.</p>
          </div>
        </div>

      </div>

    </div>

  </section><!-- End Services Section -->
  

  <!-- ======= Testimonials Section ======= -->
  <section id="testimonials" class="testimonials">

    <div class="container" data-aos="fade-up">

      <header class="section-header">
        <h2>Testimonials</h2>
        <p>What they are saying about us</p>
      </header>
      <!-- bootstrp carosel -->
      <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="row">
              <div class="col-lg-4">
                <div class="testimonial-item">
              <div class="stars">
                <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i
                  class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
              </div>
              <p>
                Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium
                quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.
              </p>
              <div class="profile mt-auto">
                <img [src]="getTextureUrl('testimonials/testimonials-1.jpg')" class="testimonial-img" alt="">
                <h3>Saul Goodman</h3>
                <h4>Store Owner</h4>
              </div>
            </div>
              </div>
              <div class="col-lg-4">
                <div class="testimonial-item">
              <div class="stars">
                <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i
                  class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
              </div>
              <p>
                Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium
                quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.
              </p>
              <div class="profile mt-auto">
                <img [src]="getTextureUrl('testimonials/testimonials-2.jpg')" class="testimonial-img" alt="">
                <h3>Saul Goodman</h3>
                <h4>Store Owner</h4>
              </div>
            </div>
              </div>
              <div class="col-lg-4">
                <div class="testimonial-item">
              <div class="stars">
                <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i
                  class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
              </div>
              <p>
                Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium
                quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.
              </p>
              <div class="profile mt-auto">
                <img [src]="getTextureUrl('testimonials/testimonials-3.jpg')" class="testimonial-img" alt="">
                <h3>Saul Goodman</h3>
                <h4>Store Owner</h4>
              </div>
            </div>
              </div>
            </div>
          </div>
          
          <div class="carousel-item">
            <div class="row">
              <div class="col-lg-4">
                <div class="testimonial-item">
              <div class="stars">
                <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i
                  class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
              </div>
              <p>
                Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium
                quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.
              </p>
              <div class="profile mt-auto">
                <img [src]="getTextureUrl('testimonials/testimonials-1.jpg')" class="testimonial-img" alt="">
                <h3>Saul Goodman</h3>
                <h4>Store Owner</h4>
              </div>
            </div>
              </div>
              <div class="col-lg-4">
                <div class="testimonial-item">
              <div class="stars">
                <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i
                  class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
              </div>
              <p>
                Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium
                quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.
              </p>
              <div class="profile mt-auto">
                <img [src]="getTextureUrl('testimonials/testimonials-2.jpg')" class="testimonial-img" alt="">
                <h3>Saul Goodman</h3>
                <h4>Store Owner</h4>
              </div>
            </div>
              </div>
              <div class="col-lg-4">
                <div class="testimonial-item">
              <div class="stars">
                <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i
                  class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
              </div>
              <p>
                Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium
                quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.
              </p>
              <div class="profile mt-auto">
                <img [src]="getTextureUrl('testimonials/testimonials-3.jpg')" class="testimonial-img" alt="">
                <h3>Saul Goodman</h3>
                <h4>Store Owner</h4>
              </div>
            </div>
              </div>
            </div>
          </div>
          
          <div class="carousel-item ">
            <div class="row">
              <div class="col-lg-4">
                <div class="testimonial-item">
              <div class="stars">
                <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i
                  class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
              </div>
              <p>
                Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium
                quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.
              </p>
              <div class="profile mt-auto">
                <img [src]="getTextureUrl('testimonials/testimonials-1.jpg')" class="testimonial-img" alt="">
                <h3>Saul Goodman</h3>
                <h4>Store Owner</h4>
              </div>
            </div>
              </div>
              <div class="col-lg-4">
                <div class="testimonial-item">
              <div class="stars">
                <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i
                  class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
              </div>
              <p>
                Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium
                quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.
              </p>
              <div class="profile mt-auto">
                <img [src]="getTextureUrl('testimonials/testimonials-2.jpg')" class="testimonial-img" alt="">
                <h3>Saul Goodman</h3>
                <h4>Store Owner</h4>
              </div>
            </div>
              </div>
              <div class="col-lg-4">
                <div class="testimonial-item">
              <div class="stars">
                <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i
                  class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
              </div>
              <p>
                Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium
                quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.
              </p>
              <div class="profile mt-auto">
                <img [src]="getTextureUrl('testimonials/testimonials-3.jpg')" class="testimonial-img" alt="">
                <h3>Saul Goodman</h3>
                <h4>Store Owner</h4>
              </div>
            </div>
              </div>
            </div>
          </div>
          
        </div>
        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev" style="left: -10%;">
          <span class="fa fa-chevron-left text-black fa-3x" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next" style="right: -10%;">
          <span class="fa fa-chevron-right text-black fa-3x" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
      <!-- bootstrp carosel -->



    </div>

  </section><!-- End Testimonials Section -->

  <!-- ======= Recent Blog Posts Section ======= -->
  <section id="recent-blog-posts" class="recent-blog-posts">

    <div class="container" data-aos="fade-up">

      <header class="section-header">
        <p>Grow your online store. Learn the tips and tricks from experts.</p>
      </header>

      <div class="row">

        <div class="col-lg-4">
          <div class="post-box">
            <div class="post-img"><img [src]="getTextureUrl('blog/blog-1.jpg')" class="img-fluid" alt=""></div>
            <span class="post-date">Tue, September 15</span>
            <h3 class="post-title">Eum ad dolor et. Autem aut fugiat debitis voluptatem consequuntur sit</h3>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="post-box">
            <div class="post-img"><img [src]="getTextureUrl('blog/blog-2.jpg')" class="img-fluid" alt=""></div>
            <span class="post-date">Fri, August 28</span>
            <h3 class="post-title">Et repellendus molestiae qui est sed omnis voluptates magnam</h3>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="post-box">
            <div class="post-img"><img [src]="getTextureUrl('blog/blog-3.jpg')" class="img-fluid" alt=""></div>
            <span class="post-date">Mon, July 11</span>
            <h3 class="post-title">Quia assumenda est et veritatis aut quae</h3>
          </div>
        </div>

      </div>

    </div>

  </section><!-- End Recent Blog Posts Section -->


</main><!-- End #main -->

<!-- ======= Footer ======= -->
<footer id="footer" class="footer">

  <div class="footer-newsletter">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12 text-center">
          <h4>Chase your dreams. Start your online store.</h4>
          <p>Take your business online with Dukaan. Get your free online store in 30 seconds.</p>
        </div>
        <div class="text-center">
          <a href="#" routerLink="/login" class="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center text-white" style="margin-top: 30px;">
            <span>Get Started</span>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-top">
    <div class="container">
      <div class="row gy-4">
        <div class="col-lg-5 col-md-12 footer-info">
          <a href="index.html" class="logo d-flex align-items-center">
            <img [src]="getTextureUrl('logo.png')" alt="">
          </a>
          <p>boons, a silicon valley based startup launched in 2018. Since then, boons has grown from a consumer super
            app to an all-in-one marketplace helping local businesses and drivers connect with customers.</p>
          <div class="social-links mt-3">
            <a href="javascript:void(0)" class="twitter"><i class="bi bi-twitter"></i></a>
            <a href="javascript:void(0)" class="facebook"><i class="bi bi-facebook"></i></a>
            <a href="javascript:void(0)" class="instagram"><i class="bi bi-instagram"></i></a>
            <a href="javascript:void(0)" class="linkedin"><i class="bi bi-linkedin"></i></a>
          </div>
        </div>

        <div class="col-lg-2 col-6 footer-links">
          <h4>Useful Links</h4>
          <ul>
            <li><i class="bi bi-chevron-right"></i> <a routerLink="/">Home</a></li>
            <li><i class="bi bi-chevron-right"></i> <a href="https://boons.io/aboutus">About Us</a></li>
            <li><i class="bi bi-chevron-right"></i> <a href="https://boons.io/terms">Terms of Service</a></li>
            <li><i class="bi bi-chevron-right"></i> <a href="https://boons.io/privacy">Privacy Policy</a></li>
          </ul>
        </div>

        <div class="col-lg-2 col-6 footer-links">
          <h4>Our Services</h4>
          <ul>
            <li><i class="bi bi-chevron-right"></i> <a href="https://boons.io/">Business</a></li>
            <li><i class="bi bi-chevron-right"></i> <a href="https://boons.io/consumer">Consumer</a></li>
            <li><i class="bi bi-chevron-right"></i> <a href="https://boons.io/driver">Driver</a></li>
          </ul>
        </div>

        <div class="col-lg-3 col-md-12 footer-contact text-center text-md-start">
          <h4>Contact Us</h4>
          <p>
            6200 Stoneridge Mall Road, <br>
            3rd Floor, Pleasanton CA, 94588<br>
            United States <br><br>
            <strong>Phone:</strong> +1 (925) 474-4430<br>
            <strong>General:</strong> info@boons.io<br>
            <strong>Technical:</strong> support@boons.io<br>
          </p>

        </div>

      </div>
    </div>
  </div>

  <div class="container">
    <div class="copyright">
      © 2020, <strong><span> boons, Inc.</span></strong>. All Rights Reserved
    </div>
  </div>
</footer><!-- End Footer -->
